const href = location.href
export const title = '项目模板(iframe)'
export let api // 后端服务地址
export let web // 前端部署地址，用于访问本站的静态资源
export let fls // 文件服务地址
export let gis = 'development' // gis环境变量 [development|production]
export let home = '' // 首次登录加载的页面,为空默认读取第一个菜单
export let loginAccess = false // 是否允许子系统单独登录

export let deliverModel = 'router' // 项目切换模式、router：路由， component: 组件

export let encryptForNetwork = false // 启用传输体body加密，false时不应用加密逻辑
export let encryptMode = 'SM4' // ASE\SM4 AES：对称加密  SM4：国密

export let system = 'template' // 当前系统标识，用于文件服务资源标识
export let bucketName = 'grid' // 文件服务资源bucket
export let flsPathSuffix = 'static-file' // 当前bucketName如果包含旧文件服务的资源，需配置static-file
export let ledgerFormUrl = 'https://base-form.btzh.net:4443' // 动态表单微服务地址

export let origin = window.location.origin

export let REPLACE_ORIGIN = origin // 地图服务替换地址
export let REPLACE_HOSTNAME = location.hostname // 地图资源替换地址

document.title = title

if (href.includes('base-template.btzh.net')) {
    api = 'https://base-template.btzh.net:4443'
    web = 'https://base-template.btzh.net:4443'
    fls = 'https://oss-manage.btzh.net:4443'
    ledgerFormUrl = 'https://base-form.btzh.net:4443'
    loginAccess = true
}  else {
    api = 'https://base-template.btzh.net:4443'
    web = 'http://localhost:10086'
    fls = 'https://oss-manage.btzh.net:4443'
    ledgerFormUrl = 'http://localhost:10010'
    REPLACE_ORIGIN = 'https://base-template.btzh.net:4443'
    REPLACE_HOSTNAME = 'https://base-template.btzh.net:4443'
    loginAccess = true
}
